import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { CareersListPage } from '../features/careers/CareersListPage';
import { VacancyInfoPage } from '../features/careers/VacancyInfoPage';
import { VacancyApplyPage } from '../features/careers/VacancyApplyPage';
import { CareersLayout } from '../features/careers/CareersLayout';
import { CareersSignupPage } from '../features/careers/CareersSignupPage';
import { CareersLoginPage } from '../features/careers/CareersLoginPage';
import { LoginPage } from '../features/auth/LoginPage';
import { PartnerRegisterPage } from '../features/auth/PartnerRegisterPage';
import { PartnerVerifyEmailPage } from '../features/auth/PartnerVerifyEmailPage';
import { PartnerForgotPasswordPage } from '../features/auth/PartnerForgotPasswordPage';
import { PartnerResetPasswordPage } from '../features/auth/PartnerResetPasswordPage';
import { PartnerPortalShellPage } from '../features/auth/PartnerPortalShellPage';
import { MyApplicationsPage } from '../features/careers/MyApplicationsPage';
import { MyCandidateProfilePage } from '../features/careers/MyCandidateProfilePage';
import { AppShell } from '../layout/AppShell';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { UsersPage } from '../features/admin/users/UsersPage';
import { AccessManagementPage } from '../features/admin/AccessManagementPage';
import { SystemSetupHubPage } from '../features/admin/SystemSetupHubPage';
import { OrganizationAuthorityHubPage, AdvancedSecurityPage } from '../features/admin/authority/OrganizationAuthorityHubPage';
import { PositionsPage as AuthorityPositionsPage } from '../features/admin/authority/PositionsPage';
import { PositionWorkspacePage } from '../features/admin/authority/PositionWorkspacePage';
import { ReportingStructurePage } from '../features/admin/authority/ReportingStructurePage';
import { AccessProfilesPage } from '../features/admin/authority/AccessProfilesPage';
import { ApprovalRulesPage } from '../features/admin/authority/ApprovalRulesPage';
import { ResponsibilitiesPage, ActingAppointmentsPage } from '../features/admin/authority/ResponsibilitiesPage';
import { AuthorityTesterPage } from '../features/admin/authority/AuthorityTesterPage';
import { GovernanceHealthPage, ReconciliationPage } from '../features/admin/authority/GovernanceHealthPage';
import { ProcurementListPage } from '../features/procurement/ProcurementListPage';
import { ProcurementWorkspacePage } from '../features/procurement/ProcurementWorkspacePage';
import { UserDetailPage } from '../features/admin/users/UserDetailPage';
import { DepartmentsPage } from '../features/admin/departments/DepartmentsPage';
import { DepartmentDetailPage } from '../features/admin/departments/DepartmentDetailPage';
import { PositionsPage } from '../features/admin/positions/PositionsPage';
import { PositionDetailPage } from '../features/admin/positions/PositionDetailPage';
import { LocationsPage } from '../features/admin/locations/LocationsPage';
import { LocationDetailPage } from '../features/admin/locations/LocationDetailPage';
import { RolesPage } from '../features/admin/roles/RolesPage';
import { RolePermissionsPage } from '../features/admin/roles/RolePermissionsPage';
import { ApprovalMatrixHealthPage } from '../features/admin/ApprovalMatrixHealthPage';
import { ApprovalMatrixPage } from '../features/admin/approval-matrix/ApprovalMatrixPage';
import { PartnerAccountsPage } from '../features/admin/PartnerAccountsPage';
import { PartnersListPage } from '../features/partners/PartnersListPage';
import { PartnerDueDiligenceHubPage } from '../features/partners/PartnerDueDiligenceHubPage';
import { LogisticsTravelHubPage } from '../features/logistics-travel/LogisticsTravelHubPage';
import { TravelRequestsListPage } from '../features/travel/TravelRequestsListPage';
import { TravelRequestWorkspacePage } from '../features/travel/TravelRequestWorkspacePage';
import { LogisticsRequestsListPage } from '../features/logistics/LogisticsRequestsListPage';
import { LogisticsRequestWorkspacePage } from '../features/logistics/LogisticsRequestWorkspacePage';
import { AssetsListPage } from '../features/assets/AssetsListPage';
import { AssetWorkspacePage } from '../features/assets/AssetWorkspacePage';
import { VehiclesListPage } from '../features/fleet/VehiclesListPage';
import { VehicleWorkspacePage } from '../features/fleet/VehicleWorkspacePage';
import { VehicleRequestsListPage } from '../features/fleet/VehicleRequestsListPage';
import { VehicleRequestWorkspacePage } from '../features/fleet/VehicleRequestWorkspacePage';
import { WarehousesListPage } from '../features/warehouse/WarehousesListPage';
import { WarehouseWorkspacePage } from '../features/warehouse/WarehouseWorkspacePage';
import { StockRequestsListPage } from '../features/warehouse/StockRequestsListPage';
import { StockRequestWorkspacePage } from '../features/warehouse/StockRequestWorkspacePage';
import { GoodsReceiptsListPage } from '../features/warehouse/GoodsReceiptsListPage';
import { GoodsReceiptWorkspacePage } from '../features/warehouse/GoodsReceiptWorkspacePage';
import { StockAdjustmentsListPage } from '../features/warehouse/StockAdjustmentsListPage';
import { StockAdjustmentWorkspacePage } from '../features/warehouse/StockAdjustmentWorkspacePage';
import { StockCountsListPage } from '../features/warehouse/StockCountsListPage';
import { StockCountWorkspacePage } from '../features/warehouse/StockCountWorkspacePage';
import { WaybillsListPage } from '../features/dispatch/WaybillsListPage';
import { WaybillWorkspacePage } from '../features/dispatch/WaybillWorkspacePage';
import { ItemCataloguePage } from '../features/warehouse/ItemCataloguePage';
import { VCollectProjectsListPage } from '../features/vcollect/VCollectProjectsListPage';
import { VCollectProjectWorkspacePage } from '../features/vcollect/VCollectProjectWorkspacePage';
import { VCollectFormsListPage } from '../features/vcollect/VCollectFormsListPage';
import { VCollectFormWorkspacePage } from '../features/vcollect/VCollectFormWorkspacePage';
import { FormBuilderPage } from '../features/vcollect/FormBuilderPage';
import { EnumeratorsListPage } from '../features/vcollect/EnumeratorsListPage';
import { TeamsPage } from '../features/vcollect/TeamsPage';
import { SubmissionsListPage } from '../features/vcollect/SubmissionsListPage';
import { SubmissionWorkspacePage } from '../features/vcollect/SubmissionWorkspacePage';
import { PartnerWorkspacePage } from '../features/partners/PartnerWorkspacePage';
import { PartnerDdScoringSetupPage } from '../features/admin/partner-dd-scoring/PartnerDdScoringSetupPage';
import { PartnerDueDiligenceDashboardPage } from '../features/partners/PartnerDueDiligenceDashboardPage';
import { PartnerDueDiligenceReportsPage } from '../features/partners/PartnerDueDiligenceReportsPage';
import { DelegationsPage } from '../features/admin/delegations/DelegationsPage';
import { DelegationDetailPage } from '../features/admin/delegations/DelegationDetailPage';
import { AuditPage } from '../features/admin/audit/AuditPage';
import { ProgrammesPage } from '../features/projects/ProgrammesPage';
import { ProgrammeDetailPage } from '../features/projects/ProgrammeDetailPage';
import { ProjectsPage } from '../features/projects/ProjectsPage';
import { ProjectWorkspaceLayout } from '../features/projects/workspace/ProjectWorkspaceLayout';
import { StaffWorkspaceLayout } from '../features/staff/StaffWorkspaceLayout';
import { StaffDashboardPage } from '../features/staff/StaffDashboardPage';
import { MyProfilePage } from '../features/staff/MyProfilePage';
import { MyIdCardPage } from '../features/staff/MyIdCardPage';
import { MyLeavePage } from '../features/staff/MyLeavePage';
import { MyRequestsPage } from '../features/staff/MyRequestsPage';
import { MyTrainingPage } from '../features/staff/MyTrainingPage';
import { MyPerformancePage } from '../features/staff/MyPerformancePage';
import { MyPayrollPage } from '../features/staff/MyPayrollPage';
import { MyOnboardingPage } from '../features/staff/MyOnboardingPage';
import { MyProbationPage } from '../features/staff/MyProbationPage';
import { MyStaffMovementPage } from '../features/staff/MyStaffMovementPage';
import { MyRestrictedCasesPage } from '../features/staff/MyRestrictedCasesPage';
import { MySeparationPage } from '../features/staff/MySeparationPage';
import { AppraisalDetailPage } from '../features/staff/AppraisalDetailPage';
import { StaffDirectoryPage } from '../features/staff/StaffDirectoryPage';
import { HRWorkspaceLayout } from '../features/hr/HRWorkspaceLayout';
import { HRDashboardPage } from '../features/hr/HRDashboardPage';
import { StaffManagementPage } from '../features/hr/StaffManagementPage';
import { StaffDetailPage } from '../features/hr/StaffDetailPage';
import { ContractsPage } from '../features/hr/ContractsPage';
import { ContractWorkspacePage } from '../features/hr/ContractWorkspacePage';
import { VacanciesPage } from '../features/hr/VacanciesPage';
import { WorkforceRequestsPage } from '../features/hr/WorkforceRequestsPage';
import { WorkforceRequestDetailPage } from '../features/hr/WorkforceRequestDetailPage';
import { VacancyDetailPage } from '../features/hr/VacancyDetailPage';
import { ContractTemplatesPage } from '../features/hr/ContractTemplatesPage';
import { LeaveReviewPage } from '../features/hr/LeaveReviewPage';
import { LeaveRequestDetailPage } from '../features/hr/LeaveRequestDetailPage';
import { HrRequestsPage } from '../features/hr/HrRequestsPage';
import { HrRequestDetailPage } from '../features/hr/HrRequestDetailPage';
import { TrainingReviewPage } from '../features/hr/TrainingReviewPage';
import { TrainingRequestDetailPage } from '../features/hr/TrainingRequestDetailPage';
import { PerformancePage } from '../features/hr/PerformancePage';
import { PayrollPage } from '../features/hr/PayrollPage';
import { OnboardingPage } from '../features/hr/OnboardingPage';
import { OnboardingDetailPage } from '../features/hr/OnboardingDetailPage';
import { ProbationPage } from '../features/hr/ProbationPage';
import { ProbationDetailPage } from '../features/hr/ProbationDetailPage';
import { StaffMovementPage } from '../features/hr/StaffMovementPage';
import { StaffMovementDetailPage } from '../features/hr/StaffMovementDetailPage';
import { RestrictedCasesPage } from '../features/hr/RestrictedCasesPage';
import { SeparationPage } from '../features/hr/SeparationPage';
import { FinanceDashboardPage } from '../features/finance/FinanceDashboardPage';
import { ChartOfAccountsPage } from '../features/finance/ChartOfAccountsPage';
import { FiscalYearsPage } from '../features/finance/FiscalYearsPage';
import { CostCentresPage } from '../features/finance/CostCentresPage';
import { FundingSourcesPage } from '../features/finance/FundingSourcesPage';
import { GrantsPage } from '../features/finance/GrantsPage';
import { GrantDetailPage } from '../features/finance/GrantDetailPage';
import { BudgetsPage } from '../features/finance/BudgetsPage';
import { BudgetDetailPage } from '../features/finance/BudgetDetailPage';
import { FinanceSettingsPage } from '../features/finance/FinanceSettingsPage';
import { JournalEntriesPage } from '../features/finance/JournalEntriesPage';
import { IncomeRecordsPage } from '../features/finance/IncomeRecordsPage';
import { IncomeRecordDetailPage } from '../features/finance/IncomeRecordDetailPage';
import { BankAccountsPage } from '../features/finance/BankAccountsPage';
import { ProjectsFinanceSummaryPage } from '../features/finance/ProjectsFinanceSummaryPage';
import { ReportsPage } from '../features/finance/ReportsPage';
import { JournalEntryDetailPage } from '../features/finance/JournalEntryDetailPage';
import { GeneralLedgerPage } from '../features/finance/GeneralLedgerPage';
import { TrialBalancePage } from '../features/finance/TrialBalancePage';
import { ExpenseClaimsPage } from '../features/finance/ExpenseClaimsPage';
import { ExpenseClaimDetailPage } from '../features/finance/ExpenseClaimDetailPage';
import { PayablesPage } from '../features/finance/PayablesPage';
import { PayableDetailPage } from '../features/finance/PayableDetailPage';
import { ReceivablesPage } from '../features/finance/ReceivablesPage';
import { ReceivableDetailPage } from '../features/finance/ReceivableDetailPage';

// Future modules (Partners, Vendors, Procurement, Finance, Payments,
// HR, MEAL, Documents, Workflows, Notifications, Reporting) each
// become a new top-level child route here, following the same
// pattern - no restructuring needed when they're built.
const router = createBrowserRouter([
  // Genuinely public - a real sibling to the authenticated AppShell
  // tree below, not nested inside it, so it never depends on any
  // Entra session and is reachable by anyone with the link.
  {
    path: '/careers',
    element: <CareersLayout />,
    children: [
      { index: true, element: <CareersListPage /> },
      { path: 'vacancies/:id', element: <VacancyInfoPage /> },
      { path: 'vacancies/:id/apply', element: <VacancyApplyPage /> },
      { path: 'signup', element: <CareersSignupPage /> },
      { path: 'login', element: <CareersLoginPage /> },
      { path: 'my-applications', element: <MyApplicationsPage /> },
      { path: 'my-profile', element: <MyCandidateProfilePage /> },
    ],
  },
  // The new branded email-first login page and the Partner Portal
  // pages - equally public, equally must never sit under AppShell
  // (which assumes an authenticated Entra session).
  { path: '/login', element: <LoginPage /> },
  { path: '/partner/register', element: <PartnerRegisterPage /> },
  { path: '/partner/verify-email', element: <PartnerVerifyEmailPage /> },
  { path: '/partner/forgot-password', element: <PartnerForgotPasswordPage /> },
  { path: '/partner/reset-password', element: <PartnerResetPasswordPage /> },
  { path: '/partner/portal', element: <PartnerPortalShellPage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'dashboard', element: <Navigate to="/" replace /> },
      { path: 'programmes', element: <ProgrammesPage /> },
      { path: 'programmes/:programmeId', element: <ProgrammeDetailPage /> },
      {
        path: 'staff',
        element: <StaffWorkspaceLayout />,
        children: [
          { index: true, element: <StaffDashboardPage /> },
          { path: 'profile', element: <MyProfilePage /> },
          { path: 'id-card', element: <MyIdCardPage /> },
          { path: 'leave', element: <MyLeavePage /> },
          { path: 'requests', element: <MyRequestsPage /> },
          { path: 'training', element: <MyTrainingPage /> },
          { path: 'performance', element: <MyPerformancePage /> },
          { path: 'payroll', element: <MyPayrollPage /> },
          { path: 'onboarding', element: <MyOnboardingPage /> },
          { path: 'probation', element: <MyProbationPage /> },
          { path: 'movement', element: <MyStaffMovementPage /> },
          { path: 'restricted-cases', element: <MyRestrictedCasesPage /> },
          { path: 'separation', element: <MySeparationPage /> },
          { path: 'performance/:appraisalId', element: <AppraisalDetailPage /> },
          { path: 'directory', element: <StaffDirectoryPage /> },
        ],
      },
      {
        path: 'hr',
        element: <HRWorkspaceLayout />,
        children: [
          { index: true, element: <HRDashboardPage /> },
          { path: 'staff', element: <StaffManagementPage /> },
          { path: 'vacancies', element: <VacanciesPage /> },
          { path: 'workforce-requests', element: <WorkforceRequestsPage /> },
          { path: 'workforce-requests/:id', element: <WorkforceRequestDetailPage /> },
          { path: 'contract-templates', element: <ContractTemplatesPage /> },
          { path: 'leave-review', element: <LeaveReviewPage /> },
          { path: 'leave-review/:id', element: <LeaveRequestDetailPage /> },
          { path: 'requests', element: <HrRequestsPage /> },
          { path: 'requests/:id', element: <HrRequestDetailPage /> },
          { path: 'training-review', element: <TrainingReviewPage /> },
          { path: 'training-review/:id', element: <TrainingRequestDetailPage /> },
          { path: 'performance', element: <PerformancePage /> },
          { path: 'payroll', element: <PayrollPage /> },
          { path: 'onboarding', element: <OnboardingPage /> },
          { path: 'onboarding/:employeeId', element: <OnboardingDetailPage /> },
          { path: 'probation', element: <ProbationPage /> },
          { path: 'probation/:id', element: <ProbationDetailPage /> },
          { path: 'staff-movement', element: <StaffMovementPage /> },
          { path: 'staff-movement/:id', element: <StaffMovementDetailPage /> },
          { path: 'restricted-cases', element: <RestrictedCasesPage /> },
          { path: 'separation', element: <SeparationPage /> },
        ],
      },
      { path: 'hr/staff/:employeeId', element: <StaffDetailPage /> },
      { path: 'hr/contracts', element: <ContractsPage /> },
      { path: 'hr/contracts/:id', element: <ContractWorkspacePage /> },
      { path: 'hr/vacancies/:vacancyId', element: <VacancyDetailPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'projects/:projectId', element: <ProjectWorkspaceLayout /> },
      { path: 'finance', element: <FinanceDashboardPage /> },
      { path: 'finance/accounts', element: <ChartOfAccountsPage /> },
      { path: 'finance/fiscal-years', element: <FiscalYearsPage /> },
      { path: 'finance/cost-centres', element: <CostCentresPage /> },
      { path: 'finance/funding-sources', element: <FundingSourcesPage /> },
      { path: 'finance/grants', element: <GrantsPage /> },
      { path: 'finance/grants/:id', element: <GrantDetailPage /> },
      { path: 'finance/budgets', element: <BudgetsPage /> },
      { path: 'finance/budgets/:id', element: <BudgetDetailPage /> },
      { path: 'finance/settings', element: <FinanceSettingsPage /> },
      { path: 'finance/journal-entries', element: <JournalEntriesPage /> },
      { path: 'finance/journal-entries/:id', element: <JournalEntryDetailPage /> },
      { path: 'finance/general-ledger', element: <GeneralLedgerPage /> },
      { path: 'finance/trial-balance', element: <TrialBalancePage /> },
      { path: 'finance/expenses', element: <ExpenseClaimsPage /> },
      { path: 'finance/expenses/:id', element: <ExpenseClaimDetailPage /> },
      { path: 'finance/income', element: <IncomeRecordsPage /> },
      { path: 'finance/income/:id', element: <IncomeRecordDetailPage /> },
      { path: 'finance/payables', element: <PayablesPage /> },
      { path: 'finance/payables/:id', element: <PayableDetailPage /> },
      { path: 'finance/receivables', element: <ReceivablesPage /> },
      { path: 'finance/receivables/:id', element: <ReceivableDetailPage /> },
      { path: 'finance/bank-cash', element: <BankAccountsPage /> },
      { path: 'finance/projects-finance', element: <ProjectsFinanceSummaryPage /> },
      { path: 'finance/reports', element: <ReportsPage /> },
      { path: 'procurement', element: <ProcurementListPage /> },
      { path: 'procurement/:id', element: <ProcurementWorkspacePage /> },
      { path: 'admin', element: <SystemSetupHubPage /> },
      { path: 'admin/authority', element: <OrganizationAuthorityHubPage /> },
      { path: 'admin/authority/positions', element: <AuthorityPositionsPage /> },
      { path: 'admin/authority/positions/:id', element: <PositionWorkspacePage /> },
      { path: 'admin/authority/reporting', element: <ReportingStructurePage /> },
      { path: 'admin/authority/access-profiles', element: <AccessProfilesPage /> },
      { path: 'admin/authority/approval-rules', element: <ApprovalRulesPage /> },
      { path: 'admin/authority/responsibilities', element: <ResponsibilitiesPage /> },
      { path: 'admin/authority/acting', element: <ActingAppointmentsPage /> },
      { path: 'admin/authority/tester', element: <AuthorityTesterPage /> },
      { path: 'admin/authority/health', element: <GovernanceHealthPage /> },
      { path: 'admin/authority/reconciliation', element: <ReconciliationPage /> },
      { path: 'admin/authority/advanced', element: <AdvancedSecurityPage /> },
      { path: 'admin/access', element: <AccessManagementPage /> },
      { path: 'admin/users', element: <UsersPage /> },
      { path: 'admin/users/:userId', element: <UserDetailPage /> },
      { path: 'admin/departments', element: <DepartmentsPage /> },
      { path: 'admin/departments/:id', element: <DepartmentDetailPage /> },
      { path: 'admin/positions', element: <PositionsPage /> },
      { path: 'admin/positions/:id', element: <PositionDetailPage /> },
      { path: 'admin/locations', element: <LocationsPage /> },
      { path: 'admin/locations/:id', element: <LocationDetailPage /> },
      { path: 'admin/roles', element: <RolesPage /> },
      { path: 'admin/roles/:roleId/permissions', element: <RolePermissionsPage /> },
      { path: 'admin/approval-matrix-health', element: <ApprovalMatrixHealthPage /> },
      { path: 'admin/approval-matrix', element: <ApprovalMatrixPage /> },
      { path: 'admin/partner-accounts', element: <PartnerAccountsPage /> },
      { path: 'partners-hub', element: <PartnerDueDiligenceHubPage /> },
      { path: 'logistics-travel', element: <LogisticsTravelHubPage /> },
      { path: 'travel', element: <TravelRequestsListPage /> },
      { path: 'travel/:id', element: <TravelRequestWorkspacePage /> },
      { path: 'logistics/requests', element: <LogisticsRequestsListPage /> },
      { path: 'logistics/requests/:id', element: <LogisticsRequestWorkspacePage /> },
      { path: 'logistics/assets', element: <AssetsListPage /> },
      { path: 'logistics/assets/:id', element: <AssetWorkspacePage /> },
      { path: 'logistics/fleet', element: <VehiclesListPage /> },
      { path: 'logistics/fleet/:id', element: <VehicleWorkspacePage /> },
      { path: 'logistics/vehicle-requests', element: <VehicleRequestsListPage /> },
      { path: 'logistics/vehicle-requests/:id', element: <VehicleRequestWorkspacePage /> },
      { path: 'logistics/warehouses', element: <WarehousesListPage /> },
      { path: 'logistics/warehouses/:id', element: <WarehouseWorkspacePage /> },
      { path: 'logistics/stock-requests', element: <StockRequestsListPage /> },
      { path: 'logistics/stock-requests/:id', element: <StockRequestWorkspacePage /> },
      { path: 'logistics/goods-receipts', element: <GoodsReceiptsListPage /> },
      { path: 'logistics/goods-receipts/:id', element: <GoodsReceiptWorkspacePage /> },
      { path: 'logistics/stock-adjustments', element: <StockAdjustmentsListPage /> },
      { path: 'logistics/stock-adjustments/:id', element: <StockAdjustmentWorkspacePage /> },
      { path: 'logistics/stock-counts', element: <StockCountsListPage /> },
      { path: 'logistics/stock-counts/:id', element: <StockCountWorkspacePage /> },
      { path: 'logistics/waybills', element: <WaybillsListPage /> },
      { path: 'logistics/waybills/:id', element: <WaybillWorkspacePage /> },
      { path: 'logistics/item-catalogue', element: <ItemCataloguePage /> },
      { path: 'vcollect', element: <VCollectProjectsListPage /> },
      { path: 'vcollect/projects/:id', element: <VCollectProjectWorkspacePage /> },
      { path: 'vcollect/forms', element: <VCollectFormsListPage /> },
      { path: 'vcollect/forms/:id', element: <VCollectFormWorkspacePage /> },
      { path: 'vcollect/forms/:id/versions/:versionId/build', element: <FormBuilderPage /> },
      { path: 'vcollect/enumerators', element: <EnumeratorsListPage /> },
      { path: 'vcollect/teams', element: <TeamsPage /> },
      { path: 'vcollect/submissions', element: <SubmissionsListPage /> },
      { path: 'vcollect/submissions/:id', element: <SubmissionWorkspacePage /> },
      { path: 'partners', element: <PartnersListPage /> },
      { path: 'partners/:id', element: <PartnerWorkspacePage /> },
      { path: 'admin/partner-due-diligence-scoring', element: <PartnerDdScoringSetupPage /> },
      { path: 'partners-dashboard', element: <PartnerDueDiligenceDashboardPage /> },
      { path: 'partners-reports', element: <PartnerDueDiligenceReportsPage /> },
      { path: 'admin/delegations', element: <DelegationsPage /> },
      { path: 'admin/delegations/:id', element: <DelegationDetailPage /> },
      { path: 'admin/audit', element: <AuditPage /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
